import * as routes from "../data/links/routes";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const SetUpRoute = () => {
  let { user } = useAuth();
  return user.setup === 1 ? <Outlet /> : <Navigate to={routes.INTRO} />;
};
export default SetUpRoute;
